import MarkdownDocument from "./MarkdownDocument";
import StaticMarkdownDocument from "./StaticMarkdownDocument";
export default MarkdownDocument;

export { MarkdownDocument, StaticMarkdownDocument };
